/**
 * Created by Zhao, Marcus on 10/18/2022.
 * Description:
 * EmailSetting model
 * ------ maintenance history ------
 */
export class EmailSetting {

    // Email Settings
    emailAddress: string;
    folderName: string;
    keepOnServer: string;
    receviedTimeStamp: string;
    takeOverlapDays: string;
    tenantGuid: string;
    timer: string;

    static parse(res): EmailSetting {
        const emailSetting = new EmailSetting();
        emailSetting.emailAddress = res['emailAddress'];
        emailSetting.folderName = res['folderName'];
        emailSetting.keepOnServer = res['keepOnServer'];
        emailSetting.receviedTimeStamp = res['receviedTimeStamp'];
        emailSetting.takeOverlapDays = res['takeOverlapDays'];
        emailSetting.tenantGuid = res['tenantGuid'];
        // if timer is empty ,set default value.
        emailSetting.timer = res['timer'] || '0/10 * * * *?';

        return emailSetting;
    }



    // According to the rules set by the server，UI should get periodSeconds from timer,
    // like time =  0/10****? periodSeconds set 10.
    static parseTime(timer: string) {
        const index = timer.indexOf(' ');
        return parseInt(timer.substring(2, index), 0);
    }

    // According to the rules set by the server ,format like this.
    static setTime(time: string) {
        return `0/${time} * * * * ?`;
    }
}

export class MailSetting {

    mailAddressFrom: string;
    useSMTPAuth: boolean;
    SMTPAuthUser: string;
    SMTPAuthPassword: string;
    SMTPEncryptionSecurity: string;
    mailPersonalName: string;
    emailSMTPServerAddress: string;
    emailSMTPServerPortAddress: string;
    relayToAddress: string;
    fromDisplayName: string;

    static parse(res): MailSetting {
        const mailSetting = new MailSetting();
        mailSetting.mailAddressFrom = res['mailAddressFrom'];
        mailSetting.useSMTPAuth = res['useSMTPAuth'];
        mailSetting.SMTPAuthUser = res['SMTPAuthUser'];
        mailSetting.SMTPAuthPassword = res['SMTPAuthPassword'];
        mailSetting.SMTPEncryptionSecurity = res['SMTPEncryptionSecurity'];
        mailSetting.mailPersonalName = res['mailPersonalName'];
        mailSetting.emailSMTPServerAddress = res['emailSMTPServerAddress'];
        mailSetting.emailSMTPServerPortAddress = res['emailSMTPServerPortAddress'];
        mailSetting.relayToAddress = res['relayToAddress'];
        mailSetting.fromDisplayName = res['fromDisplayName'];

        return mailSetting;
    }
}
